<template>
  <img :class='$style.image' :data-src='src' :src='placeholder' ref='img' />
</template>

<script>
let observer;
let observerNum = 0;

export default {
  name: "ImageLazy",
  props: {
    lazy: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default:
        "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    },
    fallback: String,
    src: String
  },
  mounted() {
    const $img = this.$refs.img;
    if (!this.lazy) {
      this.loadImg($img);
      return;
    }
    if (!("IntersectionObserver" in window)) {
      this.loadImg($img);
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(this.handerIntersecationObserver, {
        threshold: 0.1
      });
    }
    observer.observe($img);
    observerNum++;
  },
  methods: {
    handerIntersecationObserver(entries) {
      for (let i = 0; i < entries.length; i++) {
        let entry = entries[i];
        if (entry.intersectionRatio > 0) {
          observer.unobserve(entry.target);
          observerNum--;
          this.loadImg(entry.target);

          if (observerNum === 0) {
            this.unObserve();
          }
        }
      }
    },
    unObserve() {
      observer.disconnect();
      observer = null;
    },
    async loadImg(img) {
      const src = img.dataset.src;
      try {
        await this.fetchImage(src);
      } catch (error) {
        console.log("img loading errr  %o", error);
        return;
      }
      img.src = src;
    },
    fetchImage(url) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = url;
        image.onload = resolve;
        image.onerror = reject;
      });
    }
  }
};
</script>

<style lang='scss' module>
.image {
  // display: block;
  // width: 100%;
}
</style>